import React, { useEffect, useState } from "react";
import { Form, Table } from "react-bootstrap";
import { FaEdit } from "react-icons/fa";
import { FaTrash } from "react-icons/fa6";
import SplitPane from "react-split-pane";
import UpdateFormMetadata from "./UpdateFieldNotificationCheckMeta";
import { CiSearch } from "react-icons/ci";
import Swal from "sweetalert2";
import DeletedFieldNotificationCheckMeta from "./DeletedFieldNotificationCheckMeta";
import CustomEditCheckActivities from "../CommonProperties/CustomEditCheckActivities";
import CustomEditCheckQuery from "../CommonProperties/CustomEditCheckQuery";
import TableProperties from "../CommonProperties/TableProperties";
import AddEmailForNotify from "../CommonProperties/AddEmailForNotify";
import { useParams } from "react-router-dom";
import UseToggle from "../../../../Hooks/UseToggle";
import { studyLevelFormManagementServices } from "../../../../APIServices/studyLevelFormManagementServices";
import { studyOnboardingService } from "../../../../APIServices/studyOnboarding";
import { studyOtherSettingsServices } from "../../../../APIServices/studyOtherSettingsServices";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import AddFieldNotificationCheckForm from "./AddFieldNotificationCheckForm";
import DuplicateFieldNotificationCheckMetaForm from "./DuplicateFieldNotificationCheckForm";
import Pagination from "../../../Pagination";

const FieldNotificationCheckDataList = ({ onMouseDown, tableRef }) => {
  const [searchData, setSearchData] = useState("");
  const [checkData, setCheckata] = useState("");
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [fieldNotificationCheckList, setFieldNotificationCheckList] = useState([]);
  const [fieldNotificationCheckListCount, setFieldNotificationCheckListCount] = useState(0);
  const [deletedFieldNotificationCheck, setDeletedFieldNotificationCheck] = useState([]);
  const [deletedFieldNotificationCheckCount, setDeletedFieldNotificationCheckCount] = useState(0);
  const { toggle, setToggle, toggle1, setToggle1, toggle2, setToggle2 } = UseToggle();
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("activities");
  const [checkId, setCheckId] = useState("");
  const [activityLoader, setActivityLoader] = useState(false);
  const [checkActivity, setCheckActivity] = useState([]);
  const [checkActivityCount, setCheckActivityCount] = useState(0);
  const [tableColumns, setTableColumns] = useState({});
  let { studyId } = useParams();
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isDuplicateFormOpen, setIsDuplicateFormOpen] = useState(false);

  const formColumn = [
    { columnLabel: 'Type', columnName: 'TYPE', columnType: 'text' },
    { columnLabel: 'Label', columnName: 'LABEL', columnType: 'text' },
    { columnLabel: 'Schema', columnName: 'SCHEMA', columnType: 'text' },
    { columnLabel: 'Event', columnName: 'EVENT', columnType: 'text' },
    { columnLabel: 'Form', columnName: 'FORM', columnType: 'text' },
    { columnLabel: 'Field', columnName: 'FIELD', columnType: 'text' },
    { columnLabel: 'Subject', columnName: 'SUBJECT', columnType: 'text' },
    { columnLabel: 'Query Message', columnName: 'QUERYMESSAGE', columnType: 'textarea' },
  ];

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(fieldNotificationCheckListCount / itemsPerPage);

  const getStudyLevelFieldCheckNotification = async (e) => {
    setLoading(true);
    let data = await studyLevelFormManagementServices.getStudyLevelFieldCheckNotification(
      studyId,
      "active",
      searchData,
      pageNumber,
      itemsPerPage
    );
    setFieldNotificationCheckList(data?.data || []);
    setFieldNotificationCheckListCount(data?.count || 0);
    setLoading(false);
  };

  const [pageNumberDeleted, setPageNumberDeleted] = useState(1);
  const [itemsPerPageDeleted, setItemsPerPageDeleted] = useState(10);

  const getDeleteStudyLevelFieldCheckNotification = async (pageNumberDeleted, itemsPerPageDeleted) => {
    let data = await studyLevelFormManagementServices.getStudyLevelFieldCheckNotification(
      studyId, "deleted", "", pageNumberDeleted, itemsPerPageDeleted
    );
    setDeletedFieldNotificationCheck(data?.data || []);
    setDeletedFieldNotificationCheckCount(data?.count || 0);
  };

  const getStudyAuditTrials = async (pageNumber, itemsPerPage) => {
    setActivityLoader(true);
    let data = await studyOnboardingService.getStudyAuditTrials(
      "studyLevelFieldCheckNotification",
      studyId,
      checkData?.checkId,
      StudyMode,
      pageNumber, itemsPerPage
    );
    setCheckActivity(data?.data || []);
    setCheckActivityCount(data?.count || 0);
    setActivityLoader(false);
  };

  const getTablePropertiesData = async (e) => {
    let data = await studyOtherSettingsServices.getTablePropertiesData("studyLevelFieldCheckNotification", studyId);
    setTableColumns(data?.data || {});
  };

  useEffect(() => {
    getTablePropertiesData()
  }, []);

  useEffect(() => {
    getStudyLevelFieldCheckNotification();
  }, [searchData, pageNumber, itemsPerPage]);

  const softDeleteRestoreStudyLevelFieldCheckNotification = async (id, type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} field notification check!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.studyId = studyId;
        userData.id = id;
        userData.type = type;
        let data =
          await studyLevelFormManagementServices.softDeleteRestoreStudyLevelFieldCheckNotification(
            userData
          );
        if (data?.statusCode === 200) {
          getStudyLevelFieldCheckNotification();
          setCheckId("")
          if (type === "restore") {
            getDeleteStudyLevelFieldCheckNotification(pageNumberDeleted, itemsPerPageDeleted);
          }
        }
      }
    });
  };

  const updateTableProperties = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Update Table Property!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Update it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.studyId = studyId;
        userData.type = "studyLevelFieldCheckNotification";
        userData.columns = tableColumns;
        let data = await studyOtherSettingsServices.updateTableProperties(userData);
        if (data?.statusCode === 200) {
          getStudyLevelFieldCheckNotification();
          getTablePropertiesData();
        }
      }
    });
  };

  return (
    <>
      <div className="justify-content-between toolbar border-bottom hstack p-1" style={{height: 36}}>
        <div className="hstack gap-1">
          <i
            title={isFormOpen ? "Close Form" : "Add Form Metadata"}
            onClick={() => {
              setIsFormOpen(!isFormOpen);
              setIsDuplicateFormOpen("")
              setCheckId("");
            }}
            className={`fa-solid ${
              isFormOpen ? "fa-table-list" : "fa-plus-square CP"
            }`}
          />
          {fieldNotificationCheckListCount > 0 && (
            <>
              <div className="vr"></div>
              <i
                title={isDuplicateFormOpen ? "Close Duplicate Form" : "Duplicate Form Metadata"}
                onClick={() => {
                  setIsDuplicateFormOpen(!isDuplicateFormOpen);
                  setIsFormOpen("");
                  setCheckId("");
                }}
                className={`fa-solid ${
                  isDuplicateFormOpen ? "fa-table-list" : "fa-clone CP"
                }`}
              />
              <div className="vr"></div>
              <div className="position-relative">
                <Form.Control
                  type="Search"
                  onChange={(e) => setSearchData(e.target.value)}
                  value={searchData}
                  placeholder="Search..."
                  style={{ width: 200, padding: "3px 10px" }}
                ></Form.Control>
                <CiSearch
                  className="CP position-absolute bg-white"
                  title="Search"
                  style={{ width: 15, top: 4, right: 7 }}
                />
              </div>
            </>
          )}
        </div>
        <div className="hstack gap-2">
          {fieldNotificationCheckListCount > 0 && (
            <button
              onClick={() => {
                setToggle1();
                getDeleteStudyLevelFieldCheckNotification(pageNumberDeleted, itemsPerPageDeleted);
              }}
              className={`updateProfile`}
              style={{ fontSize: 12 }}
            >
              Table Properties
            </button>
          )}
          {deletedFieldNotificationCheckCount > 0 &&
            <button
              onClick={() => {
                setToggle1();
                getDeleteStudyLevelFieldCheckNotification(pageNumberDeleted, itemsPerPageDeleted);
              }}
              className={`updateProfile`}
            >
              Deleted History
            </button>
          }
        </div>
      </div>
      <SplitPane
        split="horizontal"
        className="position-relative"
        style={{ height: "calc(100vh - 182px)" }}
        minSize={checkId ? "40%" : "100%"}
      >
        <SplitPane
          split="vertical"
          minSize={20}
          className="position-relative"
          defaultSize={(isFormOpen || isDuplicateFormOpen) ? "20%" : "100%"}
        >
          {isFormOpen ? <AddFieldNotificationCheckForm getStudyLevelFieldCheckNotification={getStudyLevelFieldCheckNotification} /> : isDuplicateFormOpen && <DuplicateFieldNotificationCheckMetaForm />}
          {loading ? (
            <PageLoader/>
          ) : fieldNotificationCheckList?.length === 0 ? (
            <div className="hstack justify-content-center h-100">
              <NoDataFoundTable MSG={"Field notification check not found!"} />
            </div>
          ) : (
            <>
              <Table ref={tableRef} className="m-0 custom-table" hover striped>
                <thead className="position-sticky top-0 z-1">
                  <tr>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 0)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Sr.
                    </th>
                    {!tableColumns["TYPE"] &&
                      <th onMouseDown={(e) => onMouseDown(e, 1)}>Type</th>
                    }
                    {!tableColumns["LABEL"] &&
                      <th onMouseDown={(e) => onMouseDown(e, 2)}>Label</th>
                    }
                    {!tableColumns["SCHEMA"] &&
                      <th onMouseDown={(e) => onMouseDown(e, 4)}>Schema</th>
                    }
                    {!tableColumns["EVENT"] &&
                      <th onMouseDown={(e) => onMouseDown(e, 5)}>Event</th>
                    }
                    {!tableColumns["FORM"] &&
                      <th onMouseDown={(e) => onMouseDown(e, 6)}>Form</th>
                    }
                    {!tableColumns["FIELD"] &&
                      <th onMouseDown={(e) => onMouseDown(e, 7)}>Field</th>
                    }
                    {!tableColumns["SUBJECT"] &&
                      <th onMouseDown={(e) => onMouseDown(e, 8)}>Subject</th>
                    }
                    {!tableColumns["QUERYMESSAGE"] &&
                      <th onMouseDown={(e) => onMouseDown(e, 9)}>Query Message</th>
                    }
                    <th
                      onMouseDown={(e) => onMouseDown(e, 10)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Edit
                    </th>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 11)}
                      style={{ width: 55 }}
                      className="text-center"
                    >
                      Delete
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {fieldNotificationCheckList?.map((checkData, index) => (
                    <tr
                      key={index}
                      className={`CP ${checkId === checkData?._id ? "selectedhighlightedRow" : ""}`}
                      onClick={() => {setIsFormOpen(false); setIsDuplicateFormOpen(false) }}
                      title="View Details"
                    >
                      <td
                        onClick={() => {
                          setCheckata(checkData);
                          setCheckId(checkData?._id);
                        }}
                        className="text-center"
                      >
                        {index + 1 + startIndex}.
                      </td>
                      {!tableColumns["TYPE"] &&
                        <td onClick={() => { setCheckata(checkData); setCheckId(checkData?._id); }}>
                          {checkData?.type === "byEvent" ? "By Event" : "Global"}
                        </td>}
                      {!tableColumns["LABEL"] &&
                        <td onClick={() => { setCheckata(checkData); setCheckId(checkData?._id); }}>
                          {checkData?.label}
                        </td>}
                      {!tableColumns["SCHEMA"] &&
                        <td onClick={() => { setCheckata(checkData); setCheckId(checkData?._id); }}>
                          {checkData?.schemaName}
                        </td>}
                      {!tableColumns["EVENT"] &&
                        <td onClick={() => { setCheckata(checkData); setCheckId(checkData?._id); }}>
                          {checkData?.eventName} {checkData?.timePointId && `(${checkData?.timePointLabel})`}
                        </td>}
                      {!tableColumns["FORM"] &&
                        <td onClick={() => { setCheckata(checkData); setCheckId(checkData?._id); }}>
                          {checkData?.formName} ({checkData?.formCode})
                        </td>}
                      {!tableColumns["FIELD"] &&
                        <td onClick={() => { setCheckata(checkData); setCheckId(checkData?._id); }}>
                          {checkData?.fieldName} ({checkData?.fieldCode})
                        </td>}
                      {!tableColumns["SUBJECT"] &&
                        <td onClick={() => { setCheckata(checkData); setCheckId(checkData?._id); }}>
                          {checkData?.subject}
                        </td>}
                      {!tableColumns["QUERYMESSAGE"] &&
                        <td onClick={() => { setCheckata(checkData); setCheckId(checkData?._id); }}>
                          {checkData?.queryMessage}
                        </td>}
                      {(
                        <>
                          <td className="text-center" title={`Update ${checkData?.label}`} onClick={() => {
                            setCheckata(checkData);
                            setToggle();
                          }}>
                            <FaEdit className="text-muted"/>
                          </td>
                          <td className="text-center" title={`Delete ${checkData?.label}`} onClick={() =>
                            softDeleteRestoreStudyLevelFieldCheckNotification(checkData?._id, "delete")
                          }>
                            <FaTrash className="text-danger"/>
                          </td>
                        </>
                      )}
                    </tr>

                  ))}
                </tbody>
              </Table>
              <div className="position-sticky bottom-0 start-0">
                <Pagination
                  totalPage={totalPage}
                  pageNumber={pageNumber}
                  itemsPerPage={itemsPerPage}
                  totalItems={fieldNotificationCheckListCount}
                  setPageNumber={setPageNumber}
                  setItemsPerPage={setItemsPerPage}
                />
              </div>
            </>
          )}
        </SplitPane>
        {checkId && (
          <div className={isFullScreen ? "full-screen-component" : ""}>
            <div className="hstack paginate fixed_tab_button justify-content-between pt-1 border-bottom bg-light">
              <div className="hstack me-1 gap-1">
                  {[
                    "activities",
                    "activities",
                    "add Email Notify",
                  ].map((tab) => (
                    <button
                      key={tab}
                      className={`buttonForTabs px-2 ${
                        activeTab === tab ? "activee" : ""
                      }`}
                      onClick={() => setActiveTab(tab)}
                      title={tab.charAt(0).toUpperCase() + tab.slice(1)}
                    >
                      {tab.charAt(0).toUpperCase() + tab.slice(1)}
                    </button>
                  )
                )}
              </div>
              <div className="d-flex gap-1">
                <div className="toolbar">
                  <i
                    className="fa-solid fa-angle-down"
                    onClick={() => setCheckId(false)}
                  ></i>
                </div>
                <div className="toolbar">
                  <i
                    className={`fa-solid me-2 ${
                      !isFullScreen ? "fa-maximize" : "fa-minimize"
                    }`}
                    title={!isFullScreen ? "Full Mode" : "Original Mode"}
                    onClick={toggleFullScreen}
                  ></i>
                </div>
              </div>
            </div>
            {activeTab === "activities" && (
              <CustomEditCheckActivities
                onMouseDown={onMouseDown}
                tableRef={tableRef}
                checkActivity={checkActivity}
                activityLoader={activityLoader}
                getStudyAuditTrials={getStudyAuditTrials}
                checkData={checkData}
                checkActivityCount={checkActivityCount}
              />
            )}
            {activeTab === "customCheck" && (
              <CustomEditCheckQuery
                checkData={checkData}
                type="fieldNotification"
                getStudyLevelCustomEditCheck={getStudyLevelFieldCheckNotification}
              />
            )}
            {activeTab === "add Email Notify" && (
              <AddEmailForNotify
                checkData={checkData}
                getStudyLevelFieldCheckNotification={getStudyLevelFieldCheckNotification}
              />
            )}
          </div>
        )}
      </SplitPane>
      <UpdateFormMetadata
        Show={!toggle}
        Hide={setToggle}
        checkData={checkData}
        setCheckId={setCheckId}
        setCheckata={setCheckata}
        getStudyLevelFieldCheckNotification={getStudyLevelFieldCheckNotification}
        Title={"Update Field Notification Check Meta"}
      />
      <TableProperties
        Show={!toggle2}
        Hide={setToggle2}
        Title={"Table Properties"}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        formColumn={formColumn}
        tableColumns={tableColumns}
        setTableColumns={setTableColumns}
        updateTableProperties={updateTableProperties}
      />
      <DeletedFieldNotificationCheckMeta
        Show={!toggle1}
        Hide={setToggle1}
        setCheckId={setCheckId}
        checkId={checkId}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        deletedFieldNotificationCheck={deletedFieldNotificationCheck}
        getDeleteStudyLevelFieldCheckNotification={getDeleteStudyLevelFieldCheckNotification}
        deletedFieldNotificationCheckCount={deletedFieldNotificationCheckCount}
        pageNumberDeleted={pageNumberDeleted}
        itemsPerPageDeleted={itemsPerPageDeleted}
        setPageNumberDeleted={setPageNumberDeleted}
        setItemsPerPageDeleted={setItemsPerPageDeleted}
        softDeleteRestoreStudyLevelFieldCheckNotification={softDeleteRestoreStudyLevelFieldCheckNotification}
        Title={"Deleted Field Notification Check Meta History"}
      />
    </>
  );
};

export default FieldNotificationCheckDataList;
